import React from "react";
import { Segment } from "semantic-ui-react";
import CuentaCard from "./CuentaCard";
import PropTypes from "prop-types";

const CuentaList = ({ cuentas }) => {
  return (
    <Segment.Group raised>
      {cuentas &&
        cuentas.map((cuenta) => (
          <CuentaCard key={cuenta.numeroCuenta} cuenta={cuenta} />
        ))}
    </Segment.Group>
  );
};

CuentaList.propTypes = {
  cuentas: PropTypes.array.isRequired,
};

export default CuentaList;
